import React, { useState } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import longIcon from "../assets/images/long-icon.png";

const Nav = styled.nav`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px 2rem;
  background-color: rgba(100, 255, 200, 0.2);
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
`;

const Logo = styled.div`
  font-size: 1.8rem;
  font-weight: bold;
  color: #fff;
  display: flex;
  align-items: center;

  img {
    height: 60px;
    width: 130px;
    margin-right: 10px;
  }
`;

const NavLinks = styled.ul`
  display: flex;
  gap: 2rem;

  @media (max-width: 768px) {
    flex-direction: column;
    position: absolute;
    top: 60px;
    right: ${({ isOpen }) => (isOpen ? "0" : "-100%")};
    width: 100%;
    max-width: 100vw;
    background-color: rgba(100, 100, 100, 0.99);
    padding: 2rem;
    transition: right 0.3s ease-in-out;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }
`;

const NavItem = styled.li`
  font-size: 1rem;
  font-weight: 500;
  color: #fff;
  transition: all 0.3s ease;

  &:hover {
    color: #0099cc;
  }

  @media (max-width: 768px) {
    margin: 1rem 0;
    font-size: 1.2rem;
  }
`;

const HamburgerIcon = styled.div`
  display: none;
  flex-direction: column;
  cursor: pointer;

  @media (max-width: 768px) {
    display: flex;
  }

  span {
    height: 3px;
    width: 25px;
    background: #fff;
    margin-bottom: 4px;
    border-radius: 5px;
    transition: all 0.3s ease;

    &:nth-child(1) {
      transform: ${({ isOpen }) =>
        isOpen ? "rotate(45deg) translate(5px, 5px)" : "rotate(0)"};
    }

    &:nth-child(2) {
      opacity: ${({ isOpen }) => (isOpen ? "0" : "1")};
      transform: ${({ isOpen }) =>
        isOpen ? "translateX(-20px)" : "translateX(0)"};
    }

    &:nth-child(3) {
      transform: ${({ isOpen }) =>
        isOpen ? "rotate(-45deg) translate(5px, -6px)" : "rotate(0)"};
    }
  }
`;

const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <Nav>
      <Logo>
        <Link to="/" style={{ display: "flex" }}>
          <img src={longIcon} alt="テクノロイグ" />
        </Link>
      </Logo>
      <HamburgerIcon isOpen={isOpen} onClick={toggleMenu}>
        <span></span>
        <span></span>
        <span></span>
      </HamburgerIcon>
      <NavLinks isOpen={isOpen}>
        <NavItem>
          <Link to="/products">プロダクト</Link>
        </NavItem>
        <NavItem>
          <Link to="/recruitment">採用情報</Link>
        </NavItem>
        <NavItem>
          <Link to="/company">会社概要</Link>
        </NavItem>
        <NavItem>
          <Link to="/contact">お問い合わせ</Link>
        </NavItem>
      </NavLinks>
    </Nav>
  );
};

export default Navigation;
